var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"my-2"},[_vm._v("Public Records")]),_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('psi-simple-table',{attrs:{"items":_vm.publicRecords,"headers":_vm.headers}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }